import type { RefObject } from 'react';
import { useRef } from 'react';
import type { FieldValues, Path, UseFormRegister } from 'react-hook-form';
import styled from 'styled-components';
import { BasicInputStyles } from './BasicInput';

type InputDateProps<Fields extends FieldValues> = {
  value: string | number | undefined;
  changeFunction?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  name: Path<Fields>;
  errorMessage?: string;
  required?: boolean;
  disabled?: boolean;
  inputSize?: string;
  min?: string;
  max?: string;
  ref?: RefObject<HTMLInputElement>;
  register?: UseFormRegister<Fields>;
  id?: string;
};

const Input = styled(BasicInputStyles)``;

const InputDate = <Fields extends FieldValues>({
  id,
  name,
  changeFunction,
  required,
  disabled,
  min,
  max,
  inputSize,
  errorMessage,
  register
}: InputDateProps<Fields>) => {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const registerFunc = register ? register : () => {};
  const inputRef = useRef<HTMLInputElement>(null);
  const openPicker = () => {
    if (
      inputRef &&
      inputRef.current &&
      'showPicker' in HTMLInputElement.prototype
    ) {
      inputRef.current.showPicker();
    }
  };
  return (
    <Input
      id={id ? `${id}-input-date` : undefined}
      type="date"
      name={name}
      inputSize={inputSize}
      required={required}
      disabled={disabled}
      pattern="\d{4}-\d{2}-\d{2}"
      min={min}
      max={max}
      errorMessage={errorMessage}
      onClick={openPicker}
      onChange={changeFunction}
      ref={inputRef}
      {...registerFunc(name)}
    />
  );
};

export { InputDate };
